import { STAND } from 'app/constants'
import { Stand } from 'app/types'
import { hasConsent } from 'features/consent/store'

export const pushGtmEvent = <T extends Record<string, unknown>>(
  event: string,
  data?: T
) => {
  if (STAND !== Stand.mainnet) return
  // NOTE: FE-330 — analytics events exist only with analytics consent; GTM
  // itself is injected after the choice (features/consent/utils/browser-tags)
  if (!hasConsent('analytics')) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...data })
}
